import morphism from 'morphism';

import {
  automationRequest,
  automationResponse,
  orderResponseSchema,
  productResponse
} from '@hero/schemas';

import { api } from '../api';

import { endpoints } from './endpoints';

export const services = {
  create: formData =>
    api
      .post(endpoints.automations(), morphism(automationRequest.create, formData))
      .then(res => morphism(automationResponse.automation, res?.data?.data)),
  list: params =>
    api
      .get(endpoints.automations(), { params })
      .then(res => morphism(automationResponse.list, res?.data?.data)),
  detail: id =>
    api
      .get(endpoints.automation(id))
      .then(res => morphism(automationResponse.automation, res.data.data)),
  update: (code, body) =>
    api
      .put(endpoints.automation(code), morphism(automationRequest.update, body))
      .then(res => morphism(automationRequest.update, res?.data?.data)),
  products: code =>
    api
      .get(endpoints.products(code))
      .then(res => morphism(productResponse.searchProductSchema, res.data.data)),
  delete: code => api.delete(endpoints.automation(code)).then(res => res.data.data),
  deleteOrder: (code, orderCode) =>
    api.delete(endpoints.automationOrderDelete(code, orderCode)).then(res => res.data.data),
  start: (code, body) => api.put(endpoints.automation(code), body).then(res => res.data.data),
  spendingSummary: code => api.get(endpoints.spendingSummary(code)).then(res => res.data.data),
  orders: (code, params) =>
    api.get(endpoints.orders(code), { params }).then(res => res?.data?.data),
  orderDetail: (code, orderCode, params) =>
    api.get(endpoints.orderDetail(code, orderCode), { params }).then(res => res?.data?.data),
  sendReminder: ({ params, body }) =>
    api.post(endpoints.sendReminder(params), body).then(res => res?.data?.data),
  upcomingSends: (code, params) =>
    api.get(endpoints.upcomingSends(code), { params }).then(res => {
      return morphism(orderResponseSchema.upcomingSendsSchema, res?.data?.data);
    }),
  duplicate: (code, body) =>
    api
      .post(endpoints.detailDuplicate(code), morphism(automationRequest.duplicate, body))
      .then(res => res.data.data),
  goLiveFlags: code => api.get(endpoints.goLiveFlags(code)).then(res => res.data.data)
};
